import CalendarService from '../../services/Calendar.service';
import { AppThunk } from '../app.store';
import { RAvailUrlProvider } from '../../../common/RAvailUrlProvider';
import { RA_ASSIGMENT_DETAILS_REDUCER, RA_FETCH_ASSIGNMENTS_FAILURE, RA_FETCH_ASSIGNMENTS_INITIATE, RA_FETCH_ASSIGNMENTS_SUCCESS } from '../Slices/AssignmentDetailsSlice';
import { updateWorkingDays } from '../Slices/DateNavigationSlice';
import { FXPServiceCatalog, FxpServiceFactory } from '@fxp/fxpservices-di';
import { FxpHttpService, UserInfoService } from '@fxp/fxpservices';
import moment from 'moment';

const calendarService = CalendarService.getSingleton();
const urlProvider = new RAvailUrlProvider();
const httpService = FxpServiceFactory.getServiceInstance(
        FXPServiceCatalog.FxpHttpService
    ) as FxpHttpService;
const userInfo = FxpServiceFactory.getServiceInstance(FXPServiceCatalog.UserInfoService) as UserInfoService;
const useralias = userInfo.getCurrentUser();
export const fetchAssignmentDetails = (
  userAlias: string,
  startdate: string,
  enddate: string,
): AppThunk => {
  return async dispatch => {
    dispatch(RA_FETCH_ASSIGNMENTS_INITIATE());
    
    try {
      // Step 1: Fetch recommended hours
      const fetchProjectEventsByRequestedDates = true;
      const recommendedResponse = await calendarService.fetchTalentRecommendedHours(
        userAlias, 
        moment(startdate).startOf('day').toDate(),
        moment(enddate).endOf('day').toDate(),
        fetchProjectEventsByRequestedDates
      );

      // Step 2: Filter project events and get resource request IDs
      const projectEvents = recommendedResponse?.eventDetails?.filter(
        event => event.eventCategory.toLowerCase() === "project"
      ) || [];

      
      const resourceRequestIds = projectEvents
        .map(event => {
          const requestId = event?.customProperties?.ResourceRequestId;
          // Ensure we're working with strings
          return requestId ? String(requestId).trim() : null;
      })
      .filter(Boolean) as string[];

      const outlookEvents = recommendedResponse?.outlookCalendarDetails;

      console.log('Resource Request IDs (before API call):', resourceRequestIds); // Debug logging

      if (resourceRequestIds.length > 0) {
        try {
          const forecastData = await calendarService.getForecastVariance(
            userAlias,
            null,
            resourceRequestIds
          );

          console.log('Forecast Data:', forecastData); // Debug logging

          if (forecastData.length > 0) {
            recommendedResponse.eventDetails = calendarService.mergeForecastVariance(
              recommendedResponse.eventDetails,
              projectEvents,
              forecastData
            );
          }
        } catch (forecastError) {
          console.error('Error fetching forecast variance:', forecastError);
        }
      }
      if (outlookEvents?.dayWiseAvailability && Object.keys(outlookEvents.dayWiseAvailability).length > 0) {
        const url = urlProvider.GetAvailabilityConfigUrl();
        const body ={
          resourceAliases: [
            useralias,
          ],
        };
        try{
          const response = await httpService.post(url,body,{'Content-Type': 'application/json;',});
          recommendedResponse.outlookCalendarDetails.isBusinessHoursEnabled = response?.data[0]?.settings?.forecast?.businesshours?.isEnabled? response.data[0].settings.forecast.businesshours.isEnabled : false;
        } catch (configError) {
          console.error('Error fetching availability config:', configError);
        }
      }
      dispatch(RA_ASSIGMENT_DETAILS_REDUCER(recommendedResponse));
      
      // Update working days from Outlook work preferences
      // This will be used by getDailyGrainDateList to generate working days based on user's Outlook configuration
      if (outlookEvents?.workPreferences?.workingDays && outlookEvents.workPreferences.workingDays.length > 0) {
        dispatch(updateWorkingDays(outlookEvents.workPreferences.workingDays));
      }
      
      dispatch(RA_FETCH_ASSIGNMENTS_SUCCESS());
    } catch (error) {
      console.error('Error fetching assignment details:', error);
      dispatch(RA_FETCH_ASSIGNMENTS_FAILURE());
      throw error;
    }
  };
};


